class RouteViewCollection extends App.Collections.BaseCollection {
  url = "RouteView";
  model = App.Models.RouteView;

  getPendingRoutesToMonitor = obj => {
    this.reset();

    var collection = (function(collection) {
      return collection;
    })(this);

    if (typeof obj.filter !== "string") {
      obj.filter = JSON.stringify(obj.filter);
    }

    var ajax = new Monet.Ajax();
    ajax.url = "RouteView/Monitor";
    ajax.method = "POST";
    ajax.data = obj.filter;
    ajax.success = function(data) {
      if (obj.success && data) {
        var dataLenght = data.length;

        for (var i = 0; i < dataLenght; i++) {
          var model = new collection.model();
          model.set(data[i]);

          try {
            collection.add(model);
          } catch (err) {
            console.log(err);
          }
        }

        obj.success(collection);
      }
    };
    ajax.send();
  };
}

App.Collections.RouteViews = RouteViewCollection;
